import { registerPlugin } from '@capacitor/core';
import { isAndroid } from './Platform';

/**
 * Wraps the Android `AudioForegroundService` Capacitor plugin. Call
 * `start({title, body})` when a meditation starts playing so Android keeps
 * the WebView alive on the Lock Screen; `stop()` when playback ends or the
 * user closes the mini-player.
 *
 * No-op on iOS and web — iOS uses `UIBackgroundModes: audio`, web uses
 * normal browser audio semantics.
 */
const AudioForegroundService = registerPlugin('AudioForegroundService');

export async function start({ title, body } = {}) {
    if (!isAndroid()) return;
    try {
        await AudioForegroundService.start({
            title: title || 'Meditation playing',
            body: body || 'Tap to return to the session'
        });
    } catch (err) {
        console.warn('[AudioForegroundService] start failed', err);
    }
}

export async function stop() {
    if (!isAndroid()) return;
    try {
        await AudioForegroundService.stop();
    } catch (err) {
        console.warn('[AudioForegroundService] stop failed', err);
    }
}

export default { start, stop };
